module.exports = __webpack_public_path__ + "static/media/map-marker-alt.b10af92e.svg";